import React, { useContext, useEffect, useRef, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import { IoSearchSharp } from "react-icons/io5";
import axios from 'axios';
import { UserContext } from '../../App';

export const SearchBar = ({ query, setQuery, data, load }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { user } = useContext(UserContext)

  const handleSearch = () => {
    setSearchParams({ 'id': query })
  }

  return (
    <div className="space-y-5">
      <div className="flex w-full text-sm sm:text-base">
        <input className="block w-full ring-1 ring-inset z-10 -mr-[1px] focus:-mr-[2px] ring-neutral-300 focus:ring-emerald-700 focus:outline-none focus:ring-2 p-4 ps-5 md:ps-10 text-gray-900 placeholder:text-neutral-500" id="default-search" autoComplete='off' placeholder="Indtast titel, forfatter eller ISBN ..." value={query} onChange={(e) => setQuery(e.target.value)} onKeyDown={(e) => e.key === 'Enter' ? handleSearch() : ""} />
        {/* <div className="filters w-fit h-auto border-y border-neutral-300 flex gap-4">
          <div className="subject p-4 ps-5">
            <input type="text" className="text-gray-900 bg-white w-full outline-none" placeholder="Emne" />
          </div>
          <div class="h-auto my-2 w-[1px] bg-neutral-200"></div>
          <div className="subject p-4 ps-5 md:min-w-40 lg:min-w-64">
            <input type="text" className="text-gray-900 bg-white w-full outline-none" placeholder="Vælg stand" />
          </div>
        </div>*/}
        <div onClick={handleSearch} className="bg-size-200 bg-pos-0 hover:bg-pos-100 transition-all duration-150 ease-in-out text-white bg-gradient-to-r from-emerald-600 to-emerald-700 p-2 h-auto px-4 aspect-[1/1] cursor-pointer flex justify-center items-center text-2xl"><IoSearchSharp /></div>
      </div>
      {typeof data !== 'undefined' && !load && <h2 className="text-base sm:text-lg md:text-xl"><span className="font-semibold">{data.filter(book => (typeof user !== 'undefined' ? book.dbBook.ejer !== user._id : typeof book !== 'undefined')).length}</span> resultater fundet</h2>}
    </div>
  )
}